module.exports = __webpack_public_path__ + "static/media/Copy of DJI_0042.8c9b8df2.jpg";